export const DEFAULT_DATE_FORMAT = 'dd-MM-yyyy';
export const CURRENT_DATE_FORMAT = 'dd.MM.yyyy';
export const SHORT_MONTH_DATE_FORMAT = 'dd-MMM-yyyy';
export const SHORT_MONTH_DATE_FORMAT_PRIMENG = 'dd-M-yy';
